import { FormControl, InputLabel, Select, MenuItem, Typography, SelectChangeEvent, FormHelperText } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { SelectCstProps } from "./types";

const SelectCst: React.FC<SelectCstProps> = ({ label, labelId, placeholder, name, options, value, required, error, onChange, readOnly, errorMessage, sxTypography }) => {
  const theme = useTheme();

  return (
    <FormControl
      fullWidth
      required={ required }
      sx={ {
        "& .MuiOutlinedInput-root": {
          borderRadius: "0.5rem",
          height: "2.27rem",
          "& fieldset": {
            borderColor: theme.customColors.border
          },
          "& .MuiOutlinedInput-input": {
            height: "100%",
            boxSizing: "border-box",
            display: "flex",
            alignItems: "center",
            paddingTop: 0,
            paddingBottom: 0
          }
        },
        "& .MuiInputLabel-root": {
          fontSize: "0.875rem"
        },
        "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
          transform: "translate(14px, 0.5rem) scale(1)"
        },
        "& .MuiFormLabel-root": {
          color: theme.customColors.textPrimary
        },
        "& .MuiInputBase-root.Mui-focused fieldset": {
          color: theme.customColors.borderPrimaryCta,
          borderColor: theme.customColors.borderPrimaryCta
        },
        "& .MuiInputLabel-root.Mui-focused.MuiInputLabel-shrink": {
          color: theme.customColors.borderPrimaryCta
        },
        "& .MuiSvgIcon-root": {
          color: theme.customColors.textPrimary
        },
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: theme.customColors.textDisabledAlternative, // colore del testo disabilitato
          opacity: 1                     // disattiva il grigio pallido
        }
      } }
    >
      { label && <InputLabel sx={ { color:  theme.customColors.borderPrimaryCta } }>{ label }</InputLabel> }
      <Select
        labelId={ labelId }
        inputProps={ labelId ? { "aria-labelledby": labelId } : undefined }
        label={ label }
        placeholder={ placeholder }
        name={ name }
        value={ value }
        error={ error }
        onChange={ onChange as (e: SelectChangeEvent<unknown>) => void }
        disabled={ readOnly }
      >
        { options.map((option, index) => (
          <MenuItem
            key={ index }
            sx={ { textTransform: "capitalize", whiteSpace: "normal" } }
            title={ option?.label }
            value={ option.value }
            data-label={ option.label }
          >
            <Typography
              sx={ {
                ...sxTypography,
                maxWidth: "400px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                textTransform: "capitalize"
              } }
            >
              { option?.label }
            </Typography>
          </MenuItem>)
        ) }
      </Select>
      { error && <FormHelperText error={ error } >{ errorMessage }</FormHelperText> }
    </FormControl>
  );
};

export default SelectCst;
